<!-- 组队赢好礼 -->
<template>
  <div :class="$style.team">
    <!-- 队伍规则 -->
    <team-rules style="position: absolute; top: 1.07rem; right: 1.12rem" />
    <!-- 队伍信息 -->
    <team-info ref="team-info" @login="$emit('login')" />
    <!-- 回归特别礼 -->
    <special-gift @login="$emit('login')" @no-team="showNoTeam" @go-lottery="$emit('go-lottery')" />
    <!-- 抽奖券获取 -->
    <lottery-ticket
      @login="$emit('login')"
      @no-team="showNoTeam"
      @go-lottery="$emit('go-lottery')"
    />
    <!-- 未加入队伍提示 -->
    <popup-frame ref="no-team" size="mini">
      <p style="font-size: 0.32rem; font-family: 'Source Han Serif SC Bold'; line-height: 1.5">
        您尚未加入队伍，<br />是否要加入队伍领取丰厚奖励呢？
      </p>
      <div style="display: flex; justify-content: space-between; margin-top: 0.5rem; gap: 1rem">
        <!-- 创建队伍 -->
        <button :class="$style['btn-create-team']" @click="showCreateTeam" />
        <!-- 加入队伍 -->
        <button :class="$style['btn-join-team']" @click="showJoinTeam" />
      </div>
    </popup-frame>
  </div>
</template>

<script>
import { TeamInfo, SpecialGift, LotteryTicket, TeamRules } from './components'
import { PopupFrame } from '@/components/widgets'

export default {
  name: 'TheTeam',
  components: {
    TeamInfo,
    SpecialGift,
    LotteryTicket,
    TeamRules,
    PopupFrame
  },
  methods: {
    showNoTeam() {
      this.$refs['no-team'].show()
    },
    showCreateTeam() {
      this.$refs['no-team'].hide()
      this.$refs['team-info'].showCreateTeam()
    },
    showJoinTeam() {
      this.$refs['no-team'].hide()
      this.$refs['team-info'].showJoinTeam()
    }
  }
}
</script>

<style lang="less" module>
.team {
  .background-fill('./images/team-bg.jpg');

  position: relative;
  height: 13.1rem;
  margin-top: -0.01rem;
  padding-top: 2.18rem;
}

.btn-create-team {
  .size(1.95rem, 0.66rem);
  .background-fill('./images/btn-create-team.png');
}

.btn-join-team {
  .size(1.95rem, 0.66rem);
  .background-fill('./images/btn-join-team.png');
}
</style>
